import { PersonInfo, Pronoun, ROLE } from '../../consts';
import image from './brian-hulme.jpg';

export const BrianHulme: PersonInfo = {
  firstName: 'Brian',
  lastName: 'Hulme',
  image,
  pronoun: Pronoun.HE,
  role: ROLE.PRODUCT_DESIGNER,
};
